var services = angular.module("fourToldServices", ["ngResource", "ngCookies"]);

services.factory("services", function($resource, esb, $window, cryptool, $location) {
    return {
        user: {
            setData: function(data) {
                $window.localStorage.setItem('userData',unescape(cryptool.encryptData(JSON.stringify(data))));
            },
            getData: function() {
                if ($window.localStorage.getItem('userData')) {
                    return JSON.parse(cryptool.decryptData($window.localStorage.getItem('userData')));
                } else {
                    return;
                }
            },
            setPhoto: function(data) {
                var CHUNK_SIZE = 0x8000; // arbitrary number here, not too small, not too big
                var index = 0;
                var array = new Uint8Array(data);
                var length = array.length;
                var result = '';
                var slice;
                while (index < length) {
                    slice = array.slice(index, Math.min(index + CHUNK_SIZE, length)); // `Math.min` is not really necessary here I think
                    result += String.fromCharCode.apply(null, slice);
                    index += CHUNK_SIZE;
                }
                $window.localStorage.setItem('userPhoto', btoa(result));
            },
            setLogo: function(data) {
                var CHUNK_SIZE = 0x8000; // arbitrary number here, not too small, not too big
                var index = 0;
                var array = new Uint8Array(data);
                var length = array.length;
                var result = '';
                var slice;
                while (index < length) {
                    slice = array.slice(index, Math.min(index + CHUNK_SIZE, length)); // `Math.min` is not really necessary here I think
                    result += String.fromCharCode.apply(null, slice);
                    index += CHUNK_SIZE;
                }
                $window.localStorage.setItem('userLogo', btoa(result));
            },

            getPhoto: function() {
                if ($window.localStorage.getItem('userPhoto')) {
                    return $window.localStorage.getItem('userPhoto');
                } else {
                    return;
                }
            },

            getLogo: function() {
                if ($window.localStorage.getItem('userLogo')) {
                    return $window.localStorage.getItem('userLogo');
                } else {
                    return;
                }
            },

            userServices: function(token, jqueryParams) {
                var objParam = {};
                // objParam['scoreDocVal'] = "0.9";
                // objParam['typeDocVal'] = "DNI_old_front";

                if (jqueryParams && jqueryParams !== null &&
                    jqueryParams.scoreDocVal && jqueryParams.scoreDocVal !== null &&
                    jqueryParams.typeDocVal && jqueryParams.typeDocVal !== null){
                    objParam['scoreDocVal'] = jqueryParams.scoreDocVal;
                    objParam['typeDocVal'] = jqueryParams.typeDocVal;
                }
                let isAgent =  window.sessionStorage.getItem('mode') == 'asesorweb' ? true : false;
                let currentSessionType = isAgent ? "AGENT" : "BORROWER";
                let currentSessionUser = null;
                if ($location.search().user_teller_agent && $location.search().user_teller_agent!='undefined'){
                    currentSessionUser = $location.search().user_teller_agent;
                }
                let currentSessionAction = null;
                if ($location.search().action && $location.search().action!='undefined'){
                    currentSessionAction = $location.search().action;
                }

                let params = null;
                if ($location.search().params && $location.search().params!='undefined'){
                    params = $location.search().params;
                }
                return $resource(esb + "/security/auth/user", {}, {
                    userData: {
                        method: "GET",
                        headers: {
                            "Authorization": token
                        },
                        params: {
                          reloadData: false,
                          deviceId:  "",
                          phoneID: "Navegador y version",
                          clientChannel : "WEB",
                          currentSessionType: currentSessionType,
                          currentSessionUser: currentSessionUser,
                          currentSessionAction: currentSessionAction,
                          params : params
                        }
                    },

                    userPhoto: {
                        url: esb + '/security/auth/user/avatar',
                        method: "GET",
                        responseType: "arraybuffer",
                        transformResponse: function(data, headersGetter) {
                            return {
                                data: data
                            };
                        },
                        headers: {
                            "Authorization": token,
                            'Accept': "image/png"
                        }
                    },

                    updatePhoto: {
                        url: esb + '/security/auth/user/avatar',
                        method: "POST",
                        transformRequest: angular.identity,
                        headers: {
                            'Content-Type': undefined,
                            "Authorization": token
                        }
                    },

                    uploadReceipt: {
                        url: esb + '/security/auth/user/files/upload/',
                        method: "POST",
                        transformationRequest: angular.identity,
                        headers: {
                            'Content-Type': undefined,
                            "Authorization": token
                        },
                        data: "@formData",
                        params: objParam
                    }
                });
            }
        },
        
        closeSession: function(token) {
            return $resource(esb + "/openfire/session", {}, {
                request: {
                    method: "DELETE",
                    params: {},
                    headers: {
                        "Authorization": token
                    }
                }
            })
        },

        conversation_history: function(token) {
            return $resource(esb + '/openfire/conversations?start=:start&maxRows=:maxRows', {
                countryID: '@countryID',
                action: '@action'
            }, {
                request: {
                    method: "GET",
                    params: {start: '@start', maxRows: '@maxRows'},
                    headers: {
                        "Authorization": token
                    }
                },
                channel: {
                    method: "GET",
                    url: esb + '/openfire/conversations?start=:start&maxRows=:maxRows', /*filter=\"alternateChannelId\":\"602d545c2ccf47000105914c\"*/
                    params: {start: '@start', maxRows: '@maxRows'},
                    headers: {
                        "Authorization": token
                    }
                },
            })
        },       

        userTags: function() {
            return $resource(esb + "/security/auth/user/:userName/tags", {}, {
                getTags: {
                    method: "GET",
                    params: { userName: '@userName' }
                }
            })
        },    
        location: function(token) {
            return $resource(esb + "feed/country/:countryID/:action", {
                countryID: '@countryID',
                action: '@action'
            }, {
                countries: {
                    method: "GET",
                    headers: {
                        "Authorization": token
                    }
                },
                states: {
                    method: "GET",
                    headers: {
                        "Authorization": token
                    }
                },
                currency: {
                    method: "GET",
                    headers: {
                        "Authorization": token
                    }
                }
            })
        },

        login: function(token) {
            //http://192.168.0.137:8090/security/oauth/toke
            return $resource(esb + "/token", {
                data: '@data',
                token: '@token'
            }, {
                login: {
                    method: "POST",
                    headers: {
                        "Authorization": token,
                        "Content-type": "application/x-www-form-urlencoded; charset=utf-8"
                    },
                    data: token
                }
            })
        },

        logout: function(token) {
            return $resource(esb + "/security/auth/logout", {}, {
                post: {
                    method: "POST",
                    headers: {
                        "Authorization": token
                    }
                }
            })
        },

        tag: function(token) {
            return $resource(esb + "/security/fin/borrower/tag?propertyType=OTHER&propertyKey=MOBILE_THEME", {}, {
                theme: {
                    method: "GET",
                    headers: {
                        "Authorization": token
                    }
                }
            })
        },
        docTypes: function() {
            return $resource(esb + "/security/fin/tag/properties/doctypes?tag=:tag", {}, {
                docTypes: {
                    method: "GET",
                    params: {tag: '@tag'}
                }
            })
        },

        specificTag: function() {
            return $resource(esb + "/security/fin/tag/properties/ui?tag=:tag", {}, {
                theme: {
                    method: "GET",
                    params: {tag: '@tag'}
                }
            })
        },

        verification: function() {
            return $resource(esb + "/security/registration/code_verification", {}, {
                code: {
                    method: "POST",
                    params: {},
                    isArray: false,
                    headers: {
                        "Content-type": "application/json"
                    }
                },
                sms_verification: {
                    method: "POST",
                    url: esb + '/security/registration/request_sms_verification',
                    params: {},
                    isArray: false,
                    headers: {
                        "Content-type": "application/json"
                    }
                }
            })
        },

        signature: function(token) {
            return $resource(esb + "/security/signing", {}, {
                signing: {
                    method: "POST",
                    params: {},
                    isArray: false,
                    headers: {
                        "Authorization": token,
                        "Content-type": "application/json"
                    }
                },
                apply: {
                    method: "PUT",
                    url: esb + "/security/signing/apply",
                    params: {},
                    isArray: false,
                    headers: {
                        "Authorization": token,
                        "Content-type": "application/json"
                    }
                },
                update: {
                    method: "POST",
                    url: esb + '/security/registration/signing/update',
                    params: {},
                    isArray: false,
                    headers: {
                        "Authorization": token,
                        "Content-type": "application/json"
                    }
                }
            })
        },

        configuration_securityQuentionsRequest: function(token) {
            return $resource(esb + "/security/fin/borrower/questions/config/request", {}, {
                getQuestions: {
                    method: "GET",
                    params: {},
                    isArray: false,
                    headers: {
                      "Authorization": token,
                      "Content-type": "application/x-www-form-urlencoded; charset=utf-8"
                    }
                },
                setAnswer:{
                    url: esb + "/security/fin/borrower/questions/config/sign",
                    method: "POST",
                    params: {},
                    isArray: false,
                    headers: {
                      "Authorization": token,
                      "Content-type": "application/json"
                    }
                }
            })
        },

        configuration_securityQuentions: function(token) {
            return $resource(esb + "/security/fin/borrower/questions/config", {}, {
                getQuestions: {
                    method: "GET",
                    params: {},
                    isArray: false,
                    headers: {
                      "Authorization": token,
                      "Content-type": "application/x-www-form-urlencoded; charset=utf-8"
                    }
                },
                setAnswer:{
                    method: "POST",
                    params: {},
                    isArray: false,
                    headers: {
                      "Authorization": token,
                      "Content-type": "application/json"
                    }
                }
            })
        },

        loanRequest: function(token, params) {
            return $resource(esb + "/security/entity/loan", {}, {
                entityLoan: {
                    method: "POST",
                    params: params,
                    isArray: false,
                    headers: {
                      "Authorization": token,
                      "Content-type": "application/json"
                    }
                }
            })
        },

        guarantors: function(token) {
            return $resource(esb + "/security/entity/loan/guarantor", {}, {
                getGuarantorLoanProposals: {
                    method: "GET",
                    params: {},
                    isArray: false,
                    headers: {
                      "Authorization": token,
                      "Content-type": "application/json"
                    }
                },
                guarantorResponse:{
                    method: "PUT",
                    url: esb + '/security/entity/loan/:loanId/guarantor/:response',
                    params: {loanId: "@loanId", response: "@response"},
                    isArray: false,
                    headers: {
                      "Authorization": token,
                      "Content-type": "application/json"
                }
              }
            })
        },

        guarantors1: function(token) {
            return $resource(esb + "/security/entity/loan/guarantor?proposalType=BORROWER", {}, {
                getGuarantorLoanProposals: {
                    method: "GET",
                    params: {},
                    isArray: false,
                    headers: {
                        "Authorization": token,
                        "Content-type": "application/json"
                    }
                }
            })
        },

        guarantors2: function(token, loanId) {
            return $resource(esb + "/security/entity/loan/guarantor?proposalType=BORROWER&loanId=" + loanId, {}, {
                getGuarantorLoanProposals: {
                    method: "GET",
                    params: {},
                    isArray: false,
                    headers: {
                        "Authorization": token,
                        "Content-type": "application/json"
                    }
                }
            })
        },

        revolvingCreditLoanRequest: function(token) {
            return $resource(esb + "/security/entity/revolvingcredit/request", {}, {
                entityLoan: {
                    method: "POST",
                    params: {},
                    isArray: false,
                    headers: {
                      "Authorization": token,
                      "Content-type": "application/json"
                    }
                }
            })
        },
        citiesRequest: function(token) {
            return $resource(esb + "/security/feed/cities/filtered", {}, {
                cities: {
                    method: "GET",
                    params: {
                      filterBy: '["textSearch"]',
                      filterValue: '@filterValue'
                    },
                    isArray: false,
                    headers: {
                      "Authorization": token,
                      "Content-type": "application/json"
                    }
                }
            })
        },

        placesRequest: function(token) {
            return $resource(esb + "/security/feed/places/:type/filtered", {type: '@type'}, {
                place: {
                    method: "GET",
                    params: {
                      countryCode: '@countryCode',
                      filterBy: '["textSearch"]',
                      filterValue: '@filterValue'
                    },
                    isArray: false,
                    headers: {
                      "Authorization": token,
                      "Content-type": "application/json"
                    }
                }
            })
        },
        placesNewRequest: function(token, parametros) {
            return $resource(esb + "/security/feed/country/:countryCode", {countryCode: '@countryCode'}, {
                place: {
                    method: "GET",
                    params: parametros
                      
                    ,
                    isArray: false,
                    headers: {
                      "Authorization": token,
                      "Content-type": "application/json"
                    }
                }
            })
        },

        externalDataSearch: function(token, parametros) {
            return $resource(esb + "/external/externaldataclient/borrower/recover/", {}, {
                search: {
                    method: "GET",
                    params: parametros,
                    isArray: false,
                    headers: {
                        "Authorization": token,
                        "Content-type": "application/json"
                    }
                }
            })
        },
        externalRegisterDataSearch: function(token) {
            return $resource(esb + "/mocks/external/borrower/info", {}, {
                search: {
                    method: "GET",
                    isArray: false,
                    headers: {
                        "Authorization": token,
                        "Content-type": "application/json"
                    }
                }
            })
        },
        externalUserRegister: function(token) {
            return $resource(esb + "/external/borrower/registration", {}, {
                register: {
                    method: "POST",
                    isArray: false,
                    headers: {
                        "Authorization": token,
                        "Content-type": "application/json"
                    }
                }
            })
        },
        externalUserRegisterManaged: function(token) {
            return $resource(esb + "/external/borrower/registration", {tag:"@tag", action:"@action"}, {
                register: {
                    method: "POST",
                    isArray: false,
                    headers: {
                        "Authorization": token,
                        "Content-type": "application/json"
                    }
                }
            })
        },
        userLocation: function(token) {
            return $resource(esb + "/security/auth/user/address", {}, {
                request: {
                    method: "POST",
                    params: {},
                    isArray: false,
                    headers: {
                      "Authorization": token,
                      "Content-type": "application/json"
                    }
                },
            })
        },

        language: $resource(esb + "/security/registration/language/list", {lang: '@lang', acceptedDate: '@acceptedDate'}, {
            getList: {
                method: "GET",
                params: {},
                isArray: true,
                headers: {
                  "Content-type": "application/json"
                }
            },
            setLanguage:{
              url: esb + '/security/auth/termsandconditions?language=:lang',
              method: "GET",
              params: {},
              isArray:false
            },
            termsAccepted : {
              url: esb + '/security/auth/user/termsandconditions',
              method: "POST",
              params: {
                version: "0.0.1",
                acceptedDate: "@acceptedDate"
              },
              isArray:false
            }
        }),

        userRegistration: $resource(esb + "/security/registration", {}, {
            setData : {
                method: "POST",
                params: {},
                isArray:false
            }
        }),

        customUserRegistration: function (scope) {
            let path = '/security/registration';

            if (scope.theme.registrationBehavior && scope.theme.registrationBehavior == 'CUSTOM') {
                path = '/security/entity/registration'  + '?aic=' + scope.theme.registrationAic;
            }

            return $resource(esb + path, {}, {
                setData : {
                    method: "POST",
                    params: {},
                    isArray:false
                }
            })
        },


        offline: function(token) {
            return $resource(esb + "/security/next", {}, {
                getNext: {
                    method: "GET",
                    params: {},
                    isArray: false,
                    headers: {
                      "Authorization": token,
                      "Content-type": "application/json"
                    }
                },

                sendData: {                 
                    method: "POST",
                    url: esb + '/security/next',
                    params: {},
                    isArray: false,
                    headers: {
                        "Authorization": token,
                        "Content-type": "application/json"            
                    }
                }
            })
        },

        refresh: function(token) {
            //http://192.168.0.137:8090/security/oauth/token
            return $resource(esb + "/security/oauth/token", {
                data: '@data',
                token: '@token'
            }, {
                refresh: {
                    method: "POST",
                    headers: {
                        "Authorization": token,
                        "Content-type": "application/x-www-form-urlencoded; charset=utf-8"
                    },
                    data: token
                }
            })
        },
        authorization: function(token) {
            return $resource(esb + "/security/oauth/check_token", {}, {
                auth: {
                    method: "POST",
                    /*url: esb + 'oauth/check_token',*/
                    params: {},
                    isArray: false,
                    headers: {
                        "Authorization": token
                    },
                    data: token
                }
            })
        },

 
        deleteUser: function(token, numero, tag, idType, country, idDocType) {
            let paramsDeleteByID="";
            if(idType == 'ID')
                paramsDeleteByID = "&country=" + country + "&idType=" + idDocType;

            var tg = "";
            if(tag) {
               tg =  "TAG=" + tag +"&";
            }
            return $resource(esb + "/security/auth/user/" + numero +"?" + tg + "channel=WEB&type=" +idType +  paramsDeleteByID, {
               
                
            }, {
                delete: {
                    method: "DELETE",
                    headers: {
                        "Authorization": token
                        
                    },
                    params: {                        
                        doubleValidationToken: "@doubleValidationToken",
                        deviceIMEIExecuter: "@deviceIMEIExecuter",
                        deviceIdExecuter: "@deviceIdExecuter"
                        

                    },
                    isArray: false,
                }
            })
        },
        unlock_user: $resource(esb + "/security/registration/user/:userName/unlock/:token",             
            {
           
            }, 
            {
                unlock: {
                    method: "PUT",                   
                    params: { userName: "@userName", token: "@token"},
                    isArray: false
            }
        }),

        recover_password_token: $resource(esb + "/security/registration/password_update", {}, {
                password: {
                    method: "PUT",                   
                    data: {
                        confirmPassword: "@confirmPassword",
                        newPassword: "@newPassword",
                        token:"@token",
                        username: "@username"
                    },
                    isArray: false
                }
            }),

        recover_password: $resource(esb + "/security/registration/password_token", {}, {
            password: {
                method: "POST",
                params: {},
                isArray: false
            }
        }),

        update_password: function(token) {
            return $resource(esb + "/security/auth/user/password", {}, {
                password: {
                    method: "PUT",
                    url: esb + '/security/auth/user/password',
                    data: {
                        oldPassword: "@oldPassword",
                        newPassword: "@newPassword"
                    },
                    isArray: false
                }
            })
        },

        update_password_form: function(token) {
            return $resource(esb + "/security/auth/user/password", {}, {
                password: {
                    method: "PUT",
                    url: esb + '/security/auth/user/password',
                    data: { 
                        newPassword: "@newPassword"
                    },
                    isArray: false
                }
            })
        },
        groups: {
            groupsServices: function(token) {
                return $resource("", {}, {
                    list: {
                        method: "GET",
                        params: {},
                        isArray: false,
                        url: esb + "/security/groups/member",
                        headers: {
                          "Authorization": token,
                          "Content-type": "application/json"
                        }
                    },
                    meetings: {
                        method: "GET",
                        params: { },
                        isArray: false,
                        url:  esb + "/security/meeting",
                        headers: {
                          "Authorization": token,
                          "Content-type": "application/json"
                        }
                    },
                    deleteMemberFromGroup: {
                        method: "DELETE",
                        params: {
                            groupId: "@groupId",
                            memberId: "@memberId"
                        },
                        isArray: false,
                        url: esb + "/security/group/:groupId/member/:memberId" ,
                        headers: {
                          "Authorization": token,
                          "Content-type": "application/json"
                        }
                    },
                    updateMeeting: {
                        method: "PUT",
                        params: {
                            meetingId: "@meetingId"
                        },
                        isArray: false,
                        url: esb + "/security/meeting/:meetingId",
                        headers: {
                          "Authorization": token,
                          "Content-type": "application/json"
                        }
                    },
                    deleteMeeting: {
                        method: "DELETE",
                        params: {
                            meetingId: "@meetingId",
                            language: "es_US"
                        },
                        isArray: false,
                        url: esb + "meeting/:meetingId",
                        headers: {
                          "Authorization": token,
                          "Content-type": "application/json"
                        }
                    }
                })
            }
        },
        loans: function(token) {
            return $resource(esb + "/4ft/customer/loans", {}, {
                loans: {
                    method: "GET",
                    params: {},
                    isArray: false,
                    headers: {
                      "Authorization": token,
                      "Content-type": "application/json"
                    }
                }
            })
        },
        channel: function(token) {
            return $resource(esb + "/openfire/conversations/alternatechannels", {}, {
                alternatechannels: {
                    method: "GET",
                    isArray: false,
                    headers: {
                      "Authorization": token,
                      "Content-type": "application/json"
                    }
                }
            })
        },
        groups: {
            groupsServices: function(token) {
                return $resource("", {}, {
                    list: {
                        method: "GET",
                        params: {},
                        isArray: false,
                        url: esb + "/security/groups/member",
                        headers: {
                            "Authorization": token,
                            "Content-type": "application/json"
                        }
                    },
                    meetings: {
                        method: "GET",
                        params: { },
                        isArray: false,
                        url:  esb + "/security/meeting",
                        headers: {
                            "Authorization": token,
                            "Content-type": "application/json"
                        }
                    },
                    deleteMemberFromGroup: {
                        method: "DELETE",
                        params: {
                            groupId: "@groupId",
                            memberId: "@memberId",
                            language: "es_US"
                        },
                        isArray: false,
                        url: esb + "group/:groupId/member/:memberId" ,
                        headers: {
                            "Authorization": token,
                            "Content-type": "application/json"
                        }
                    },
                    updateMeeting: {
                        method: "PUT",
                        params: {
                            meetingId: "@meetingId"
                        },
                        isArray: false,
                        url: esb + "/security/meeting/:meetingId",
                        headers: {
                            "Authorization": token,
                            "Content-type": "application/json"
                        }
                    },
                    deleteMeeting: {
                        method: "DELETE",
                        params: {
                            meetingId: "@meetingId",
                            language: "es_US"
                        },
                        isArray: false,
                        url: esb + "meeting/:meetingId",
                        headers: {
                            "Authorization": token,
                            "Content-type": "application/json"
                        }
                    }
                })
            }
        },
        otp: function(token, username) {
            return $resource(esb + '/security/auth/otp/:ID?type=ID', {}, {
                generate: {
                    method: "POST",
                    params: {ID: username},
                    headers: {
                        "Authorization": token,
                        "Content-type": "application/x-www-form-urlencoded; charset=utf-8"
                    }
                }
            })
        }
    }
});
